import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../apiServices/axios';
import { TENT_MEMBERS, TENT_SEND_EMAIL } from '../apiServices/api_routes';

export const GetTentMembers = createAsyncThunk('tent/GET_MEMBERS', async (_, { rejectWithValue }) => {
    try {
        const projectId = localStorage.getItem('project_id');
        const { data } = await axiosInstance.get(TENT_MEMBERS(projectId));
        return data;
    } catch (error) {
        return rejectWithValue(error?.response?.data?.detail || 'Failed to load The Tent directory');
    }
});

export const SendTentEmail = createAsyncThunk(
    'tent/SEND_EMAIL',
    async ({ toUserIds, ccUserIds, subject, messageHtml }, { rejectWithValue }) => {
        try {
            const projectId = localStorage.getItem('project_id');
            const { data } = await axiosInstance.post(TENT_SEND_EMAIL(projectId), {
                to_user_ids: toUserIds,
                cc_user_ids: ccUserIds || [],
                subject,
                message_html: messageHtml,
            });
            return data;
        } catch (error) {
            const detail = error?.response?.data?.detail;
            return rejectWithValue(typeof detail === 'string' ? detail : 'Email could not be sent. Please try again.');
        }
    },
);

const initialState = {
    members: [],
    projectName: '',
    memberCount: 0,
    loading: false,
    error: null,
    emailSending: false,
};

const tentSlice = createSlice({
    name: 'tent',
    initialState,
    reducers: {
        clearTentState: state => {
            state.members = [];
            state.projectName = '';
            state.memberCount = 0;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetTentMembers.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetTentMembers.fulfilled, (state, action) => {
                state.loading = false;
                state.members = action.payload?.members || [];
                state.projectName = action.payload?.project_name || '';
                state.memberCount = action.payload?.member_count || 0;
            })
            .addCase(GetTentMembers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load members';
            })
            .addCase(SendTentEmail.pending, state => {
                state.emailSending = true;
            })
            .addCase(SendTentEmail.fulfilled, state => {
                state.emailSending = false;
            })
            .addCase(SendTentEmail.rejected, state => {
                state.emailSending = false;
            });
    },
});

export const { clearTentState } = tentSlice.actions;
export default tentSlice.reducer;
